// extracted by mini-css-extract-plugin
export var circle = "_2l-2";
export var icon = "_2l-a";
export var iconHighlight = "_2l-0";
export var lg = "_2l-8";
export var md = "_2l-7";
export var outline = "_2l-4";
export var sm = "_2l-6";
export var square = "_2l-1";
export var xl = "_2l-9";
export var xs = "_2l-5";
export var xxs = "_2l-3";